// Canonical number type groups. The backend sends type_group / type_group_label / type_detail on every offer
// (services/number_groups.py) plus the group list; this copy is the fallback and fixes the order.
export const NUMBER_GROUPS = [
  { key: 'local', label: 'Local', description: 'Local / geographic numbers' },
  { key: 'national', label: 'National', description: 'National, non-geographic numbers' },
  { key: 'mobile', label: 'Mobile', description: 'Mobile numbers' },
  { key: '2way', label: '2-Way', description: '2-way voice: incoming and outgoing calls' },
  { key: 'tollfree', label: 'Toll-Free', description: 'Free for callers in the country' },
  { key: 'uifn', label: 'UIFN', description: 'International freephone (UIFN)' },
  { key: 'other', label: 'Other', description: 'Other numbers' },
];

const ORDER = NUMBER_GROUPS.map((g) => g.key);

export const groupOf = (o) => (o && ORDER.includes(o.type_group) ? o.type_group : 'other');
export const groupRank = (key) => { const i = ORDER.indexOf(key); return i === -1 ? ORDER.length : i; };
export const groupMeta = (key, groups = NUMBER_GROUPS) => groups.find((g) => g.key === key) || NUMBER_GROUPS.find((g) => g.key === key) || { key, label: key, description: '' };

/** [{key, label, description, items}] in canonical order, only groups that have items. */
export const groupBy = (items, groups = NUMBER_GROUPS) => {
  const by = {};
  items.forEach((o) => { (by[groupOf(o)] = by[groupOf(o)] || []).push(o); });
  return Object.keys(by).sort((a, b) => groupRank(a) - groupRank(b)).map((k) => ({ ...groupMeta(k, groups), items: by[k] }));
};

// One colour per group, used for badges and tab dots (admin catalogue and customer Get Numbers).
export const GROUP_COLORS = {
  local: { badge: 'bg-orange-100 text-orange-800 ring-orange-200', dot: 'bg-orange-500' },
  national: { badge: 'bg-purple-100 text-purple-800 ring-purple-200', dot: 'bg-purple-500' },
  mobile: { badge: 'bg-green-100 text-green-800 ring-green-200', dot: 'bg-green-500' },
  '2way': { badge: 'bg-blue-100 text-blue-800 ring-blue-200', dot: 'bg-blue-500' },
  tollfree: { badge: 'bg-teal-100 text-teal-800 ring-teal-200', dot: 'bg-teal-500' },
  uifn: { badge: 'bg-indigo-100 text-indigo-800 ring-indigo-200', dot: 'bg-indigo-500' },
  other: { badge: 'bg-gray-100 text-gray-700 ring-gray-200', dot: 'bg-gray-400' },
};
export const groupColor = (key) => GROUP_COLORS[key] || GROUP_COLORS.other;
